import React from "react";

import BannerImages from "../../../Common/BannerImages";
import LanguageTable from "../../../Common/LanguageTable";
import { templateDefaultValue } from "@constants/template";

export function Header() {
    const imagePath = React.useMemo(
        () => ["Application", "LaindingPage", "Default", "Head", "Bannier"],
        []
    );
    return (
        <div className="banner-container">
            <section className="text-section">
                <div className="banner-images">
                    <BannerImages
                        dataPath={imagePath}
                        title="Advertising Banner"
                        size="(png,jpg,jpeg ou webp)"
                    />
                </div>
                <LanguageTable
                    path={["Application", "LaindingPage", "Default", "Head"]}
                    fields={[
                        {
                            key: "Title",
                            label: "Title",
                            placeholder: "Enter the Title",
                        },
                    ]}
                    defaultTexts={
                        templateDefaultValue.Application.LaindingPage.Default
                            .Head
                    }
                    sectionTitle="Title"
                />
            </section>
        </div>
    );
}
